<template>
  <div class="sky-feedback">
    <div class="wsp-display-flex wsp-line-height-28 wsp-padding-tb-3">
      <div class="wsp-width-10 wsp-text-align-right"></div>
      <div class="wsp-width-75 font-size-18">
        <label style="color: blue;font-weight: bold;"
          >感谢您使用我们的工具或运营平台！为了不断提升服务质量，恳请您花1分钟时间分享您的使用体验。</label
        >
      </div>
    </div>
    <div class="wsp-display-flex wsp-line-height-28 wsp-padding-tb-3">
      <div class="wsp-width-20 wsp-text-align-right  font-size-14">
        <span><label style="color:red;"></label>工具：</span>
      </div>
      <div class="wsp-width-75 font-size-14" v-if="sourceFrom === 'nps'">
        <span
          ><label style="color:red;font-weight: bold;">{{ feedbackObj.toolName }}</label></span
        >
      </div>
      <div class="wsp-width-75 font-size-14" v-if="sourceFrom === 'feedback'">
        <el-select
          v-model="feedbackObj.toolId"
          popper-class="sky-feedback__autocomplete"
          class="sky-feedback__select"
          filterable
          clearable
        >
          <el-option v-for="(item, index) in toolList" :key="`tool_${index}`" :label="$t(item.label)" :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="wsp-display-flex wsp-line-height-28 wsp-padding-tb-3">
      <div class="wsp-width-20 wsp-text-align-right font-size-14 ">
        <span><label style="color: red;">* </label>节省多少时间：</span>
      </div>
      <div class="wsp-width-75 ">
        <el-radio-group v-model="feedbackObj.saveTimeRate">
          <el-radio-button label="0-25%" value="0-25%">0-25%</el-radio-button>
          <el-radio-button label="25%-50%" value="25%-50%">25%-50%</el-radio-button>
          <el-radio-button label="50%-75%" value="50%-75%">50%-75%</el-radio-button>
          <el-radio-button label="75%-90%" value="75%-90%">75%-90%</el-radio-button>
          <el-radio-button label="90%以上" value="90%以上">90%以上</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="wsp-display-flex wsp-line-height-28 wsp-padding-tb-3">
      <div class="wsp-width-20 wsp-text-align-right font-size-14">
        <span><label style="color: red;">* </label>推荐指数：</span>
      </div>
      <div class="wsp-width-75 ">
        <el-radio-group v-model="feedbackObj.recommendRating" @change="onRecommendRating">
          <el-radio-button label="0" value="0">0</el-radio-button>
          <el-radio-button label="1" value="1">1</el-radio-button>
          <el-radio-button label="2" value="2">2</el-radio-button>
          <el-radio-button label="3" value="3">3</el-radio-button>
          <el-radio-button label="4" value="4">4</el-radio-button>
          <el-radio-button label="5" value="5">5</el-radio-button>
          <el-radio-button label="6" value="6">6</el-radio-button>
          <el-radio-button label="7" value="7">7</el-radio-button>
          <el-radio-button label="8" value="8">8</el-radio-button>
          <el-radio-button label="9" value="9">9</el-radio-button>
          <el-radio-button label="10" value="10">10</el-radio-button>
        </el-radio-group>
        &nbsp;&nbsp;<span style="color: blue;font-weight: bold;">{{ recommendRatingDesc }}</span>
      </div>
    </div>
    <div class="wsp-display-flex wsp-line-height-28">
      <div class="wsp-width-20 wsp-text-align-right font-size-14">
        <span><label style="color: red;">* </label>问题或建议：</span>
      </div>
      <div class="wsp-width-75">
        <el-input
          type="textarea"
          :rows="5"
          placeholder="请输入问题或建议，最少5个字，最多200个字"
          v-model="feedbackObj.feedback"
        >
        </el-input>
      </div>
    </div>
    <div class="wsp-display-flex wsp-line-height-28">
      <div class="wsp-width-20 wsp-text-align-right"></div>
      <div class="wsp-width-75">
        <span
          ><label style="color: red;">{{ message }}</label></span
        >
      </div>
    </div>

    <div style="text-align: center; margin-top: 10px;">
      <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="onConfirm">
        确定
      </el-button>
      <el-button class="sky-branch-pattern__add" style="margin-top:5px" @click="onCancel" v-if="!isModel">
        取消
      </el-button>
    </div>
  </div>
</template>
<script type="text/babel">
import { Input, Button, RadioButton, RadioGroup, Select, Option } from 'element-ui'
import { action } from 'sky-engine/api/index'

import { TOOL } from '@/api/apiModules'
import { createFeedback, updateFeedback, getToolName } from '@/api/feedback'
import lang from '@/lang'
export default {
  name: 'SkyFeedbackDialog',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [RadioButton.name]: RadioButton,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup
  },
  props: {
    feedback: null,
    isModel: {
      type: Boolean,
      default: false
    },
    sourceFrom: {
      type: String,
      default: 'feedback'
    }
  },
  data() {
    return {
      feedbackObj: {
        id: null,
        toolId: null,
        toolName: null,
        saveTimeRate: null,
        recommendRating: null,
        feedback: null,
        npsSign: null
      },
      toolList: [],
      recommendRatingDesc: null,
      lang: lang,
      message: null
    }
  },
  created() {
    if (this.feedback) {
      this.feedbackObj.id = this.feedback.id
      this.feedbackObj.toolName = this.feedback.toolName
      this.feedbackObj.toolId = this.feedback.toolId
      this.feedbackObj.saveTimeRate = this.feedback.saveTimeRate
      this.feedbackObj.recommendRating = this.feedback.recommendRating
      this.feedbackObj.feedback = this.feedback.feedback
      this.feedbackObj.npsSign = this.feedback.npsSign
    }
  },
  mounted() {
    this.onRecommendRating(this.feedbackObj.recommendRating)
    if (this.sourceFrom === 'nps') {
      getToolName({ toolId: this.feedbackObj.toolId })
        .then(response => {
          this.feedbackObj.toolName = response.data.content?.toolDesc
        })
        .catch(e => {
          this.feedbackObj.toolId = null
          this.feedbackObj.toolName = '未知'
          throw e
        })
    } else {
      let params = {
        exactMatchArr: [],
        matchArr: [{ type: 'EXACT', fieldName: 'toolDeployRange', valueArr: ['WSP'], matchRule: 'EQ' }],
        page: 0,
        limit: 100
      }
      action(TOOL, 'listForPublic', params).then(response => {
        this.toolList = response.data.content.itemArr?.map(item => {
          return {
            id: item.id,
            label: item.toolDesc
          }
        })
      })
    }
  },
  watch: {},
  methods: {
    onConfirm() {
      if (!this.feedbackObj.toolId) {
        this.message = '请选择工具'
        return
      }
      if (!this.feedbackObj.saveTimeRate) {
        this.message = '请选择节省多少时间'
        return
      }
      if (!this.feedbackObj.recommendRating) {
        this.message = '请选择推荐指数'
        return
      }
      if (!this.feedbackObj.feedback) {
        this.message = '请填写问题或建议'
        return
      }
      if (this.feedbackObj.feedback.length > 200) {
        this.message = '问题或建议不能超过200个字'
        return
      }
      if (this.feedback && this.feedback.id) {
        updateFeedback(this.feedbackObj)
          .then(res => {
            this.$store.dispatch('OpenNotification', { message: '反馈修改成功', type: 'success' })
            this.$emit('cb')
          })
          .catch(e => {
            this.$emit('cb')
            throw e
          })
      } else {
        createFeedback(this.feedbackObj)
          .then(res => {
            this.$store.dispatch('OpenNotification', { message: '反馈创建成功', type: 'success' })
            this.$emit('cb')
          })
          .catch(e => {
            this.$emit('cb')
            throw e
          })
      }
    },
    onCancel() {
      this.$emit('cb')
    },
    onRecommendRating(value) {
      if (value && value >= 0 && value <= 6) {
        this.recommendRatingDesc = '不推荐'
      } else if (value && value >= 7 && value <= 8) {
        this.recommendRatingDesc = '可能推荐'
      } else if (value && value >= 9 && value <= 10) {
        this.recommendRatingDesc = '推荐'
      } else {
        this.recommendRatingDesc = ''
      }
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(feedback) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 280px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
